/* eslint-disable */
import React, { useMemo, useEffect, useState, useCallback } from 'react'
import { navigate } from 'gatsby-plugin-intl'

import useConfiguration from '../../hooks/useConfiguration'
import Layout from '../../components/Layout'
import CountDown from '../../components/CountDown'
import * as appConfiguration from '../../configuration'

export default function withWebsiteOpen(WrappedComponent) {
  return (props) => {
    const { pageContext, location } = props
    const { configuration, isWebsiteClosed, seoFallback, isDateElapsed } = useConfiguration()
    const [elapsedCountdown, setElapsedCountdown] = useState(null)
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
      setElapsedCountdown(isDateElapsed(configuration?.countdown))
      if (typeof window !== 'undefined') {
        setIsClient(true)
      }
    }, [configuration?.countdown, isDateElapsed, setElapsedCountdown, elapsedCountdown])

    useEffect(() => {
      let timer

      if (isClient && !elapsedCountdown) {
        timer = setTimeout(() => {
          window.location = location?.href
        }, Math.floor((new Date(configuration?.countdown) - new Date())))
      }

      return () => isClient && clearTimeout(timer)
    }, [configuration, location, isClient])

    const seo = useMemo(() => ({
      lang: pageContext?.language ?? null,
      title: seoFallback?.title ?? '',
      description: seoFallback?.description?.description ?? '',
      image: appConfiguration.app.url + seoFallback?.picture?.localFile?.childImageSharp?.fluid?.src ?? '',
      url: location?.href ?? '',
      robots: 'noindex, follow',
    }), [location.href, seoFallback.description.description, seoFallback.picture.localFile.childImageSharp.fluid.src, seoFallback.title])

    if (isWebsiteClosed) {
      return <Layout seo={seo}><CountDown countDownDate={configuration?.countdown} /></Layout>
    }

    return <WrappedComponent {...props} />
  }
}
